<div class="generic-confirmation-dialog-container">
  <h1 class="flex-fill" mat-dialog-title>{{titleText}}</h1>
  <mat-dialog-content>
    <p>{{message}}</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="primary" class="buttons" type="button" [mat-dialog-close]="true">
      Guardar
    </button>
    <button mat-raised-button color="accent" class="buttons" type="button" [mat-dialog-close]="false">
      Salir
    </button>
  </mat-dialog-actions>
</div>
